import Map from 'components/map';

export default Map;
